import React from "react";
import { connect } from "react-redux";

import {
    Container,
    Row,
    Col,
    Card, CardBody, FormSelect, CardHeader
} from "shards-react";

import PageTitle from "../../components/common/PageTitle";
import {
    requestFilesPractitioner,
    addFilePractitioner
} from "../../actions/practitioners.action";

class Files extends React.Component
{
    constructor(props) {
        super(props);
        let uuid = this.props.match.params.id;
        this.props.loadFiles(uuid);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        const formData = new FormData();
        let imagefile = document.getElementById('file');
        let typeFile = document.getElementById('type-file').value;
        formData.append('file', imagefile.files[0]);
        formData.append('type', typeFile);
        if (this.props.practitioners.data) {
            formData.append('id', this.props.practitioners.data.id);
        }
        this.props.sendFile(formData);
    };

    render() {
        const setURI = (URIData) => {
            return 'data:image/png;base64,' + URIData;
        };

        const handleAddFile = (selectorFiles) => {
            let label = document.getElementById("file-label");
            label.innerHTML = selectorFiles[0].name;
        };

        return (
            <Container fluid className="main-content-container px-4">
                {this.props.practitioners.fetching ? (
                    <div className="flex-center">
                        <div className="text-center d-block">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <Row noGutters className="page-header py-4">
                            <PageTitle title={this.props.practitioners.data && (this.props.practitioners.data.first_name + ' ' + this.props.practitioners.data.last_name)} subtitle="Fichiers" className="text-sm-left mb-3"/>
                        </Row>
                        <Row>
                            <Col className="col-lg lg-12 mb-12 col-lg-12 mb-12">
                                <Card small className="add-files">
                                    <CardBody>
                                        <form onSubmit={this.handleSubmit}>
                                            <Row>
                                               <Col lg="8">
                                                   <div className="input-group">
                                                       <div className="custom-file">
                                                           <input type="file" id="file" className="custom-file-input" onChange={(e) => handleAddFile(e.target.files)}/>
                                                               <label className="custom-file-label" htmlFor="file" id="file-label">
                                                                   Sélectioner un fichier
                                                               </label>
                                                       </div>
                                                   </div>
                                               </Col>
                                               <Col lg="4">
                                                   <Col lg="6" className="form-group text-center float-right" >
                                                       <button className="btn btn-normal btn-primary"><i className="material-icons">cloud_upload</i> Envoyer</button>
                                                   </Col>
                                                   <Col lg="6" className="form-group float-right">
                                                       <FormSelect id="type-file">
                                                           <option value="signature">Signature</option>
                                                           <option value="cni">CNI</option>
                                                       </FormSelect>
                                                   </Col>
                                               </Col>
                                           </Row>
                                        </form>

                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            {this.props.practitioners.signature &&
                            <Col sm={2}>
                                <Card small className="details-file">
                                    <CardHeader className="p-0">
                                        <Container fluid className="filters-table border-bottom">
                                            <Row>
                                                <Col className="ml-auto d-flex">
                                                    <span className="table__filters__title">Signature</span>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </CardHeader>
                                    <CardBody className="display-center">
                                        <img className="thumb" src={setURI(this.props.practitioners.signature)} alt=""/>
                                    </CardBody>
                                </Card>
                            </Col>}
                            {this.props.practitioners.cni &&
                            <Col sm={2}>
                                <Card small className="details-file">
                                    <CardHeader className="p-0">
                                        <Container fluid className="filters-table border-bottom">
                                            <Row>
                                                <Col className="ml-auto d-flex">
                                                    <span className="table__filters__title">Carte national d'identité</span>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </CardHeader>
                                    <CardBody className="display-center">
                                        <img className="thumb" src={setURI(this.props.practitioners.cni)} alt=""/>
                                    </CardBody>
                                </Card>
                            </Col>}
                        </Row>
                    </div>
                )}
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        practitioners: state['practitioners'],
    };
}

const mapDispatchToProps = dispatch => ({
    loadFiles: (e) => dispatch(requestFilesPractitioner(e)),
    sendFile: (e) => dispatch(addFilePractitioner(e))
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Files);




// WEBPACK FOOTER //
// ./src/views/Practitioners/Files.js